import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const RootRedirect = () => {
  const { user, isAuthenticated, isAuthReady } = useAuth();

  if (!isAuthReady) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === "Hr") {
    return <Navigate to="/hr/users" replace />;
  }

  if (!user.vertical_key) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to={`/${user.vertical_key}/inquiries`} replace />;
};

export default RootRedirect;
